module.exports = __webpack_public_path__ + "3eebe517d08779322aaffabf41b0274e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/stretch.png
// module id = 494
// module chunks = 0